import { useEffect, useMemo, useRef, useState } from 'react'
import { RotatingLines } from 'react-loader-spinner'
import '../../styles/Admin/AdminActuality.css'
import Button from '../Utils/Button'
import { faEdit, faPlus, faT, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from '../Utils/Modal'
import axios from 'axios'
import { toast } from 'react-toastify'
import InputText from '../Input/InputText'
import InputDate from '../Input/InputDate'
import InputFile from '../Input/InputFile'
import { Zoom } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import AccordionItem from '../Utils/AccordionItem'
import { BrowserView, MobileView } from 'react-device-detect'
import JoditEditor from 'jodit-react'
import { Buffer } from 'buffer'

function AdminActuality() {

    const [isLoading, setIsLoading] = useState(true)
    const [displayActualityAddModal, setDisplayActualityAddModal] = useState(false)
    const [displayActualityDeleteModal, setDisplayActualityDeleteModal] = useState(false)
    const [actualities, setActualities] = useState([])
    const titleRef = useRef(null)
    const [title, setTitle] = useState("")
    const [titleError, setTitleError] = useState(null)
    const dateRef = useRef(null)
    const [date, setDate] = useState(null)
    const [dateError, setDateError] = useState(null)

    const imageRef = useRef(null)
    const [image, setImage] = useState(null)
    const [imageError, setImageError] = useState(null)
    const [imageUpdate, setImageUpdate] = useState([])

    const editorRef = useRef(null)
    const [actualityContent, setActualityContent] = useState(null)
    const [actualityContentError, setActualityContentError] = useState(null)
    const config = useMemo(() => ({
        readonly: false,
        placeholder: "Écrire l'article...",
        uploader: { insertImageAsBase64URI: true },
        height: 500
    }), [])
    const configError = useMemo(() => ({
        readonly: false,
        placeholder: "Écrire l'article...",
        uploader: { insertImageAsBase64URI: true },
        height: 500,
        containerStyle: { border: '2px solid red' }
    }), [])

    useEffect(() => {

        getActuality()

    }, [])

    function resetState() {

        setTitle("")
        setTitleError(null)
        setDate(null)
        setDateError(null)

    }

    function getActuality() {

        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_URL + 'actuality?includeContent=true').then((response) => {
            if (response.data) {
                response.data.map((item) => {
                    item.date = new Date(item.date).toLocaleDateString("fr-FR")
                    item.createdAt = new Date(item.createdAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                    item.updatedAt = new Date(item.updatedAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                    item.content = Buffer.from(item.content).toString('utf-8')
                    return item
                })
                setActualities(response.data)
            }
            setIsLoading(false)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
            setIsLoading(false)
        })

    }

    function addActuality() {

        var error = []
        if (!titleRef.current.textValidation(title)) {
            error.push("Le titre est incorrect")
        }
        if (!dateRef.current.dateValidation(date)) {
            error.push("La date est incorrect")
        }
        // if (!imageRef.current.fileValidation(image)) {
        //     error.push("L'image est incorrect")
        // }
        if (!actualityContent) {
            setActualityContentError(true)
            error.push("Le contenu est incorrect")
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
        } else {
            var formData = new FormData()
            formData.append("title", title)
            formData.append("date", date)
            formData.append("file", image)
            formData.append("content", actualityContent)
            const toastId = toast.loading("Ajout...")
            axios.post(process.env.REACT_APP_API_URL + 'actuality', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                if (response.data.message === "ACTUALITY_CREATED") {
                    setTitle("")
                    setTitleError(null)
                    setDate(null)
                    setDateError(null)
                    setImage(null)
                    setImageError(null)
                    setActualityContent("")
                    setActualityContentError(null)
                    setDisplayActualityAddModal(false)
                    getActuality()
                    toast.update(toastId, { render: "Actualité créé", type: "success", isLoading: false, autoClose: 5000 })
                }
            }).catch((error) => {
                if (error.response) {
                    console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
                    var errorMessage = error.response.data.message
                    if (errorMessage === 'ERROR_PARAMS') {
                        errorMessage = "Erreur lors des paramètres transmis"
                    }
                    toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 })
                }
            })
        }

    }

    function updateActuality(actuality) {

        var error = []
        if (title.length === 0 && !date && !image && !actualityContent) {
            error.push("Aucun changement")
        }
        var titleFormat = actuality.title
        if (title.length > 0 && !titleRef.current.textValidation(title)) {
            error.push("Le titre est incorrect")
        }
        if (title.length > 0) {
            titleFormat = title
        }
        var dateFormat = new Date(actuality.date[6] + actuality.date[7] + actuality.date[8] + actuality.date[9], parseInt(actuality.date[3] + actuality.date[4]) + 1, actuality.date[0] + actuality.date[1])
        if (date && !dateRef.current.dateValidation(date)) {
            error.push("La date est incorrect")
        }
        if (date) {
            dateFormat = date
        }
        var imageFormat = actuality.image
        if (image) {
            imageFormat = image
        }
        var actualityContentFormat = actuality.content
        if (actualityContent) {
            actualityContentFormat = actualityContent
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
        } else {
            var formData = new FormData()
            formData.append("title", titleFormat)
            formData.append("date", dateFormat)
            formData.append("file", imageFormat)
            formData.append("content", actualityContentFormat)
            const toastId = toast.loading("Modification...")
            axios.put(process.env.REACT_APP_API_URL + 'actuality/' + actuality.id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                if (response.data === "ACTUALITY_UPDATED") {
                    setTitle("")
                    setTitleError(null)
                    setDate(null)
                    setDateError(null)
                    setImage(null)
                    setImageError(null)
                    setActualityContent("")
                    setActualityContentError(null)
                    getActuality()
                    setImageUpdate((prev) => ({ ...prev, [actuality.id]: Date.now() }))
                    toast.update(toastId, { render: "Actualité modifiée", type: "success", isLoading: false, autoClose: 5000 })
                }
            }).catch((error) => {
                if (error.response) {
                    console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
                    var errorMessage = error.response.data.message
                    // if (errorMessage === 'ERROR_PARAMS') {
                    //     errorMessage = "Erreur lors des paramètres transmis"
                    // } else if (errorMessage === 'ERROR_ACTUALITY_NOT_FOUND') {
                    //     errorMessage = "L'actualité est introuvable"
                    // } else if (errorMessage === 'ERROR_ACTUALITY_UPDATING') {
                    //     errorMessage = "Erreur lors de la modification de l'actualité"
                    // }
                    toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 })
                }
            })
        }

    }

    function deleteActuality(actualityId) {

        const toastId = toast.loading("Suppression...")
        axios.delete(process.env.REACT_APP_API_URL + 'actuality/' + actualityId).then((response) => {
            if (response.data === "ACTUALITY_DELETED") {
                resetState()
                getActuality()
                setDisplayActualityDeleteModal(false)
                toast.update(toastId, { render: "Actualité supprimée", type: "success", isLoading: false, autoClose: 5000 })

            }
        }).catch((error) => {
            if (error.response) {
                console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
                var errorMessage = error.response.data.message
                if (errorMessage === 'ERROR_ACTUALITY_NOT_FOUND') {
                    errorMessage = "L'actualité est introuvable"
                } else if (errorMessage === 'ERROR_ACTUALITY_DELETING') {
                    errorMessage = "Erreur lors de la suppression de l'actualité"
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 })
            }
        })

    }

    return (

        <>
            <BrowserView>
                <div className='adminActuality'>
                    {isLoading ?
                        <div className='loader'>
                            <RotatingLines
                                strokeColor={"#5b7c18"}
                                strokeWidth={"5"}
                                animationDuration={"1"}
                                width={"40"}
                                visible={true}
                            />
                        </div>
                        :
                        <>
                            <div className='adminTitle'>Actualités</div>
                            <div className='adminActualityAddButton'>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} className='buttonIcon' />} text={"Creer"} onClick={() => setDisplayActualityAddModal(true)} />
                            </div>
                            <Modal
                                displayModal={displayActualityAddModal}
                                setDisplayModal={setDisplayActualityAddModal}
                                onShow={() => resetState()}
                                onHide={() => resetState()}
                                header={"Creer une actualité"}
                                body={
                                    <>
                                        <InputText
                                            type={'text'}
                                            ref={titleRef}
                                            text={title} setText={setTitle}
                                            textError={titleError} setTextError={setTitleError}
                                            icon={<FontAwesomeIcon icon={faT} />}
                                            placeholder={"Titre"}
                                            maxLength={128}
                                        />
                                        <InputDate
                                            ref={dateRef}
                                            date={date} setDate={setDate}
                                            dateError={dateError} setDateError={setDateError}
                                        />
                                        <InputFile
                                            ref={imageRef}
                                            file={image} setFile={setImage}
                                            fileError={imageError} setFileError={setImageError}
                                            text={"Ajouter une image de couverture"}
                                            format={["jpg", "JPG", "jpeg", "JPEG", "png", "PNG"]}
                                            textExtSuccess={"Format validé"}
                                            textExtError={"Format refusé"}
                                            multiple={false}
                                        />
                                        <JoditEditor
                                            ref={editorRef}
                                            value={actualityContent}
                                            config={!actualityContentError ? config : configError}
                                            tabIndex={1}
                                            onBlur={(content) => setActualityContent(content)}
                                            onChange={(content) => content.length > 0 ? setActualityContentError(false) : null}
                                        />
                                        <div className='adminActualityAddFormButton'>
                                            <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} className='buttonIcon' />} text={"Creer"} onClick={() => addActuality()} />
                                        </div>
                                    </>
                                }
                                footer={null}
                            />
                            <Zoom delay={300} triggerOnce={true}>
                                <div className='adminActualityList'>
                                    <Accordion onSelect={(eventKey) => eventKey != null ? resetState() : null}>
                                        {actualities.map((item, index) => {
                                            return (
                                                <AccordionItem
                                                    key={index}
                                                    indexKey={index}
                                                    header={item.title}
                                                    body={
                                                        <>
                                                            <div className='adminActualityListBodyTop'>
                                                                <div className='adminActualityListBodyTopDate'>
                                                                    <div>Créé le <b>{item.createdAt}</b></div>
                                                                    <div>Modifier le <b>{item.updatedAt}</b></div>
                                                                </div>
                                                                <Button type={'danger'} icon={<FontAwesomeIcon icon={faTrash} className='buttonIcon' />} text={"Supprimer"} onClick={() => setDisplayActualityDeleteModal(item)} />
                                                            </div>
                                                            <div className='adminActualityListBodyForm'>
                                                                <InputText
                                                                    type={'text'}
                                                                    ref={titleRef}
                                                                    text={title} setText={setTitle}
                                                                    textError={titleError} setTextError={setTitleError}
                                                                    icon={<FontAwesomeIcon icon={faT} />}
                                                                    placeholder={item.title}
                                                                    maxLength={128}
                                                                    nullable={true}
                                                                />
                                                                <InputDate
                                                                    ref={dateRef}
                                                                    date={date} setDate={setDate}
                                                                    dateError={dateError} setDateError={setDateError}
                                                                    placeholder={item.date}
                                                                />
                                                                <Row>
                                                                    <Col sm={8}>
                                                                        <InputFile
                                                                            ref={imageRef}
                                                                            file={image} setFile={setImage}
                                                                            fileError={imageError} setFileError={setImageError}
                                                                            text={"Ajouter une image de couverture"}
                                                                            format={["jpg", "JPG", "jpeg", "JPEG", "png", "PNG"]}
                                                                            textExtSuccess={"Format validé"}
                                                                            textExtError={"Format refusé"}
                                                                            multiple={false}
                                                                        />
                                                                    </Col>
                                                                    <Col sm={4}>
                                                                        <img
                                                                            src={process.env.REACT_APP_API_URL + 'actuality/' + item.id + '/image?refresh=' + imageUpdate[item.id]}
                                                                            width={'100%'}
                                                                            className='adminActualityListImage'
                                                                            alt="actualityImage"
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <JoditEditor
                                                                    ref={editorRef}
                                                                    value={item.content}
                                                                    config={!actualityContentError ? config : configError}
                                                                    tabIndex={1}
                                                                    onBlur={(content) => setActualityContent(content)}
                                                                    onChange={(content) => content.length > 0 ? setActualityContentError(false) : null}
                                                                />
                                                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faEdit} className='buttonIcon' />} text={"Modifier"} onClick={() => updateActuality(item)} />
                                                            </div>
                                                        </>
                                                    }
                                                />
                                            )
                                        })}
                                    </Accordion>
                                </div>
                                <Modal
                                    displayModal={displayActualityDeleteModal}
                                    setDisplayModal={setDisplayActualityDeleteModal}
                                    onShow={() => null}
                                    onHide={() => null}
                                    header={"Supprimer une actualité"}
                                    body={
                                        <>
                                            <div className='modalBodyText'>
                                                Êtes vous sur de vouloir supprimer l'actualité :
                                                <br />
                                                <b>{displayActualityDeleteModal.title}</b>
                                            </div>
                                            <Button type={'danger'} icon={<FontAwesomeIcon icon={faTrash} className='buttonIcon' />} text={"Supprimer"} onClick={() => deleteActuality(displayActualityDeleteModal.id)} />
                                        </>
                                    }
                                    footer={null}
                                />
                            </Zoom>
                        </>
                    }
                </div>
            </BrowserView>

            <MobileView>
            </MobileView>
        </>

    )

}

export default AdminActuality